import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { CreateData, UpdateData } from '../../Tags/TagSlice/TagsSlices'
import { TwitterPicker } from 'react-color'
import Select from 'react-select'
import { IndustryOptions } from '../../../AllCellCastUser/Constant/CellCastConstant'

const CreateTagsPopup = ({ show, handleClose, tagName, setTagName, callback }: any) => {

  const [name, setName] = useState('')
  const [industry, setIndustry] = useState('')
  const [affiliate, setAffiliate] = useState('')

  const dispatch = useDispatch()
  const [tagColor, setTagColor] = useState('#7bdcb5')
  const [error, setError] = useState('')

  const handleSubmit = () => {
    if (Object.values(tagName).length === 0) {
      dispatch(
        CreateData({
          name: name,
          color: tagColor,
          industry: industry,
          affiliate: affiliate,
          isAdmin: true,
        })
      )
      setName('')
      handleClose()
    } else {
      dispatch(UpdateData({ data: { name: name, color: tagColor, industry: industry, affiliate: affiliate, isAdmin: true }, id: tagName?.id }))
      setName('')
      handleClose()
    }
  }

  useEffect(() => {
    setName(tagName?.name)
    setIndustry(tagName?.industry)
    setTagColor(tagName?.color)
    setAffiliate(tagName?.affiliate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagName?.id, show])

  const handleChangeColor = (color: any) => {
    setTagColor(color.hex)
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-450px'
        className='vh-100'
        show={show}
        onHide={() => {
          handleClose()
          setTagName('')
        }}
      >
        <div className='modal-header'>
          <h1>{tagName?.id ? 'Edit Tag' : 'Create New TAG'}</h1>
        </div>
        <div className='modal-body p-10 '>
          <label className=' col-form-label required fw-bold fs-6'>Tag Name</label>
          <input
            onBlur={() => {
              ; /^[a-zA-Z0-9_ -]{2,25}$/.test(name)
                ? setError('')
                : setError('please enter valid tag ')
            }}
            name='Description'
            value={name}
            maxLength={50}
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='i.e. "Active"'
            onChange={(e: any) => {
              setError('')
              setName(e.target.value)
            }}
          />

          {name && (
            <>
              <label className=' col-form-label required fw-bold fs-6'>Color</label>
              <div
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-white'
                style={{ backgroundColor: tagColor }}
              >
                {name}
              </div>

              <TwitterPicker onChange={handleChangeColor} triangle='hide' />
            </>
          )}
          <div className='mb-3 mt-3'>
            <label className='form-label'>Industry</label>
            <Select
              value={IndustryOptions.find((option) => option.value === industry)}
              isSearchable={false}
              name='industry'
              onChange={(e: any) => setIndustry(e.value)}
              options={IndustryOptions}
            />
          </div>

          <div className='mb-3 mt-3'>
            <label className='form-label'>Affiliate</label>
            <input
              name='affiliate'
              value={affiliate}
              type='text'
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
              placeholder='Enter affiliate code'
              onChange={(e: any) => {
                setError('')
                setAffiliate(e.target.value)
              }}
            />
          </div>

          <span className='text-danger mt-1'>{error}</span>

          <div className='d-flex justify-content-end mt-10'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  handleClose()
                  setTagName('')
                }}
                className='btn btn-sm me-2 w-100px p-3 fw-500 me-2 gray_bg_purple'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              disabled={name === ''}
              onClick={() => handleSubmit()}
            >
              <span className='indicator-label'>{tagName?.id ? 'Update' : 'Create'} tag</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateTagsPopup
